import { spacing, styled } from '@lessonup/ui-components';
import React, { PropsWithChildren } from 'react';

export const MasonryLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <StyledMasonry>{children}</StyledMasonry>;
};

const StyledMasonry = styled.div`
  column-count: 2;
  column-gap: ${spacing.size8};

  & > * {
    break-inside: avoid;
    margin-bottom: ${spacing.size8};
  }
`;
